module.exports = __webpack_public_path__ + "img/cartograph-light.c182e87b.png";